import {useMemo} from 'react'

import {StaticPartsOverviewDropdown} from '../components/StaticPartsOverview/StaticPartsOverviewDropdown'
import type {StaticPartDTO, StaticPartsTableData} from '../types'

interface useStaticPartsOverviewProps {
  staticParts: StaticPartDTO[] | undefined
  textFilter: string
}

export const useStaticPartsOverviewData = ({
  staticParts,
  textFilter
}: useStaticPartsOverviewProps) => {
  return useMemo<StaticPartsTableData[]>(() => {
    if (!staticParts) return []

    let filtered = staticParts

    if (textFilter) {
      const normalizedFilter = textFilter.trim().toLowerCase()
      filtered = staticParts.filter((staticPart) =>
        [staticPart.name, staticPart.description, staticPart.type].some((field) =>
          field.toLowerCase().includes(normalizedFilter)
        )
      )
    }

    return [...filtered]
      .sort((a, b) => a.type.localeCompare(b.type) || a.name.localeCompare(b.name))
      .map((staticPart) => ({
        id: staticPart.id,
        name: staticPart.name,
        description: staticPart.description,
        type: staticPart.type,
        address: 'N/A',
        actions: <StaticPartsOverviewDropdown staticPart={staticPart} />,
        cyPostfix: `row-${staticPart.name}-${staticPart.type}`
      }))
  }, [staticParts, textFilter])
}
